export default function TopBar() {
  return (
    <header className="w-full bg-background-50 border-b border-secondary-200/50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-5">
        <h1 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 tracking-tight">
          (MEDISOFTAS, MB)
        </h1>
      </div>
    </header>
  );
}